var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'w-' + _vm.size + ' h-' + _vm.size},[(_vm.mode)?_c('IconLoading',{attrs:{"classes":'w-' + _vm.size + ' h-' + _vm.size + ' ' + _vm.classes}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }